var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.1254 17.2818C11.739 17.8696 11.739 18.8225 11.1254 19.4103C10.5118 19.998 9.51696 19.998 8.90337 19.4103L0.52367 11.3834C0.216875 11.0895 0.0634774 10.7043 0.0634774 10.3192C0.0634774 10.1151 0.105877 9.92051 0.182698 9.74305C0.259372 9.56554 0.373029 9.39923 0.52367 9.25494L8.90338 1.22806C9.51696 0.640305 10.5118 0.640305 11.1254 1.22806C11.739 1.81582 11.739 2.76875 11.1254 3.35651L5.42787 8.81412L25.7263 8.81412C26.5941 8.81412 27.2975 9.48795 27.2975 10.3192C27.2975 11.1504 26.5941 11.8242 25.7263 11.8242L5.42787 11.8242L11.1254 17.2818Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/iconArrowLeft.27b5c425c96b8a05a26233ef106f906b.svg";
export { ForwardRef as ReactComponent };